var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWomenLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4176_13322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8588 16.8819C9.72362 16.5932 7.77801 15.5064 6.41545 13.8414C5.05288 12.1764 4.37505 10.0574 4.51901 7.91287C4.66297 5.76837 5.61799 3.75841 7.19093 2.28947C8.76388 0.820526 10.8374 0.00220941 12.9921 3.94424e-06C15.1495 -0.00207053 17.2269 0.814226 18.8032 2.2834C20.3796 3.75258 21.3369 5.76469 21.481 7.91181C21.6251 10.0589 20.9453 12.1804 19.5795 13.8461C18.2136 15.5118 16.2638 16.5971 14.1254 16.8819V19.2174H19.7919V21.4783H14.1254V26H11.8588V21.4783H6.19236V19.2174H11.8588V16.8819ZM12.9921 14.6957C14.6452 14.6957 16.2306 14.0406 17.3996 12.8746C18.5685 11.7086 19.2252 10.1272 19.2252 8.47826C19.2252 6.82931 18.5685 5.24789 17.3996 4.0819C16.2306 2.91592 14.6452 2.26087 12.9921 2.26087C11.339 2.26087 9.75357 2.91592 8.58464 4.0819C7.41571 5.24789 6.75901 6.82931 6.75901 8.47826C6.75901 10.1272 7.41571 11.7086 8.58464 12.8746C9.75357 14.0406 11.339 14.6957 12.9921 14.6957Z",
    fill: "url(#paint0_linear_4176_13322)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4176_13322",
    x1: 1.64305,
    y1: 53.95,
    x2: -19.3665,
    y2: 42.3651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4176_13322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomenLine);
export default __webpack_public_path__ + "static/media/women-line.7cc4536f79f0178f1a80e698bf7d1afb.svg";
export { ForwardRef as ReactComponent };